import { Listbox } from '@headlessui/react';
import { LockClosedIcon, CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';

function ThemeThumb({ theme, className }) {
  const url = theme?.theme_url;
  if (!url || String(url).trim() === '') {
    return (
      <div
        className={`shrink-0 rounded border border-gray-400 bg-black ${className}`}
        aria-hidden
      />
    );
  }
  return (
    <img
      src={url}
      alt={theme?.theme_name || ''}
      className={className}
    />
  );
}

export default function ThemeDropdownWithPreview({ themes, selectedTheme, setSelectedTheme, onLockedThemeClick }) {
  return (
    <Listbox value={selectedTheme} onChange={(theme) => {
      if (theme.is_available === 0) {
        onLockedThemeClick(theme);
      } else {
        setSelectedTheme(theme);
      }
    }}>
      <div className="relative mt-1">
        {/* Trigger Button */}
        <Listbox.Button className="relative w-full cursor-default rounded border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm text-sm">
          <div className="flex items-center gap-2">
            <ThemeThumb theme={selectedTheme} className="h-6 w-6 object-cover" />
            <span className="block truncate">{selectedTheme?.theme_name}</span>
          </div>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
          </span>
        </Listbox.Button>

        {/* Dropdown List */}
        <Listbox.Options className="absolute z-10 mt-1 w-full max-h-60 overflow-auto rounded bg-white py-1 text-sm shadow-lg ring-1 ring-black/5">
          {themes.map((theme) => (
            <Listbox.Option
              key={theme.theme_meta_unique_id}
              value={theme}
              className={({ active }) =>
                `relative cursor-pointer select-none px-3 py-2 ${
                  active ? 'bg-violet-100 text-violet-950' : 'text-gray-900'
                }`
              }
            >
              {({ selected }) => (
                <div className="flex items-center gap-3">
                  <ThemeThumb
                    theme={theme}
                    className="h-10 w-10 border border-gray-300 object-cover"
                  />
                  <span className="truncate">{theme.theme_name}</span>
                  {theme.is_available === 0 && (
                    <LockClosedIcon className="w-4 h-4 text-yellow-500 ml-auto" />
                  )}
                  {selected && (
                    <CheckIcon className="w-4 h-4 text-green-500 ml-2" />
                  )}
                </div>
              )}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </div>
    </Listbox>
  );
}
